import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map, tap } from "rxjs/operators";
import { Municipio } from "@/models/municipio";
import { API_URL_SERVICE, VUE_APP_SIT_PEDIDOS_API_URL } from "@/commons/config";
import { Observable } from 'rxjs';
const municipio = require("@/query/Municipio.graphql");

export class MunicipioAPI extends BaseAPI<Municipio> {
  private apiUrlSoa: String;
  private apiUrlSitPedidos: string;

  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/passe-livre`;
    this.apiUrlSoa = `${API_URL_SERVICE}/api/solicitacao`;
    this.apiUrlSitPedidos = `${VUE_APP_SIT_PEDIDOS_API_URL}/api`
  }

  public getAll(): AxiosObservable<Municipio[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(municipio),
        variables: {}
      })
      .pipe(
        map((data: any) => {
          const { municipios } = data;

          return municipios.map(
            (municipio: any) => new Municipio(municipio.id, municipio.descricao, municipio.ibge)
          );
        })
      );
  }

  public getAllSoa(): AxiosObservable<Municipio[]> {
    return this.axios.post(`${this.apiUrlSoa}/municipios`);
  }

  public getAllMunicipiosParaSitPedidos(): AxiosObservable<Municipio[]> {
    return this.axios.get(`${this.apiUrlSitPedidos}/municipios/?uf=ce`)
  }
}
